const base64DataToBlob = (base64Pdf) => {
    const byteString = window.atob(base64Pdf);
    const byteNumbers = new Array(byteString.length);
    const byteArray = new Uint8Array(byteNumbers);

    for (let i = 0; i < byteString.length; i++) {
        byteArray[i] = byteString.charCodeAt(i);
    }

    return new Blob([byteArray], { type: 'application/pdf;base64' });
};

export const downloadBase64Pdf = (fileName, base64Pdf) => {
    const link = document.createElement('a');
    const blob = base64DataToBlob(base64Pdf);

    link.href = window.URL.createObjectURL(blob);
    link.download = `${fileName}.pdf`;
    link.dispatchEvent(new MouseEvent('click'));

    window.URL.revokeObjectURL(blob);
};
